/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDiscountDetailRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetDiscountDetailResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getDiscountDetail = (request: GetDiscountDetailRequest, options?: CashRequestOptions) => post<GetDiscountDetailRequest, GetDiscountDetailResponse>("/2.0/cash/get-discount-detail", request, {...options, rejectOnError: true })